import { USER_ID_STORAGE_KEY } from '@/common/utils/users'

/**
 * Store non-sensitive user ID for session detection across tabs.
 *
 * @param {string} userId The user ID to store
 */
export function setUserId (userId) {
  localStorage.setItem(USER_ID_STORAGE_KEY, userId)
}

export function getUserId () {
  return localStorage.getItem(USER_ID_STORAGE_KEY)
}

export function removeUserId () {
  localStorage.removeItem(USER_ID_STORAGE_KEY)
}
